const smoothScroll = (elem = {}, offset = 0) => {
  const { top } = elem.getBoundingClientRect();
  window.scrollTo({
    top: top + window.scrollY - offset,
    behavior: 'smooth',
  });
};

export default smoothScroll;
